import React, { useContext, useState,  useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import Toolbar from "@material-ui/core/Toolbar";
import DynamicIcons from "../dynamic-icons/DynamicIcons";
import _ from "lodash";
import Tooltip from "@material-ui/core/Tooltip";
import { ToolbarContext } from "../../context/ToolbarContext";
import AppPopoverButton from "../popper/AppPopoverButton";
import { useHistory } from "react-router-dom";
import { TableViewSelectionContext } from "../../context/TableViewSelectionContext";
import JobUtils from "../../utils/JobsUtils";
import useSecurity from "../../hooks/useSecurity";
import UserUtils from "../../utils/UserUtils";
import { RequestContext } from "../../context/RequestContext";
import { SummaryContext } from "../../context/SummaryContext";
import { DashboardContext, Action } from "../../context/DashboardContext";
import { RequestSummaryContext } from "../../context/RequestSummaryContext";
import AlertDialog from "../common/AlertDialog";
import StatusUtils from "../../utils/StatusUtils";
import { UserContext } from "../../context/UserContext";
import QCCheckList from "../job-summary/QCCheckList";
import "../../styles/dashboard.scss";
import {iconStyle} from "./Toolbox.styles";
import {icons} from "../../constants/ActionIcons";
import { PERMITTED_ROLES } from "../../constants/UserRoles";
import { renderSourceLocationFields } from "../form/FormRenderer";
import { StyledBlueButton } from "../../styles/BootstrapStyles";
import moment from "moment";

const modalTriggerStatuses = [
  "DOWNLOADING",
  "PROCESSING",
  "INITIATE_WORKFLOW",
  "DELIVERING",
  "VETTED",
  "COMPLETE",
];

const skipModalStatuses = ["CANCELLED", "ON_HOLD", "TECH_HOLD"];
export default function DashboardToolBox({ Selected, mode, styles }) {
  const [isSelected, setSelected] = useState(Selected);
  const { selected, reset, upadateSelection } = useContext(TableViewSelectionContext);
  const [qc, enableQc] = useState(false);
  const [sourceOverride, enableSourceOverride] = useState(false);
  const history = useHistory();
  const { currentSelection, upadateAction } = useContext(ToolbarContext);
  const { userRole } = useContext(UserContext);
  const [selectedToolActon, setSelectedToolAction] = useState({
    event: null,
    action: null,
    icon: null,
    selected: null,
  });
  const [userAlert, setUserAlert] = useState(null);
  const [isAlert, setAlert] = useState(null);
  const [qcListModal, setQcList] = useState(false);  
  const { userInfo } = useSecurity();
  const { job, onJobUpdated } = useContext(SummaryContext);
  const [qcCheckList, enableQcCheckList] = useState(false);
  const [isSourceLocationModal, setIsSourceLocationModal] = useState(false);
  const [selectedSourceLocation, setSelectedSourceLocation] = useState("");
  const [currentStatus, setCurrentStatus] = useState(null);
  const [currentAlert, setCurrentAlert] = useState(null);
  const [hasShownSourceLocationModal, setHasShownSourceLocationModal] = useState(false);
  const [alertSourceLocation, setAlertSourceLocation] = useState("");
  const { status, showRequestForm } = useContext(RequestContext);
  const { updateRecordsR, selectedColumnActionR, _setColumnActionR, updateNotesRequestSummary, selectAlll, request, job: jobData } = useContext(RequestSummaryContext);
  const { updateRecords, deleteJob, selectedColumnAction, _setColumnAction, updateNotes } = useContext(DashboardContext);
  
  useEffect(() => {
    if (_.size(_.get(selected, "jobs", [])) > 0) {
      setSelected(true);
    } else {
      setSelected(Selected);
    }
  }, [selected,Selected]);

  useEffect(() => {
    if (!_.isEmpty(job)) {
      enableQc(JobUtils.isQCSupported(job));
      enableSourceOverride(JobUtils.isSourceOverrideSupported(job));
      enableQcCheckList(JobUtils.isQCCheckListEnabled(job, userRole));
    }
  }, [job,userRole]);  

  const getIconAction = (Icon) => {
    if (Icon.actionType === "Popover") {
      let popOverType = _.get(Icon, "Popover");
      return popOverType.action;
    }
  };

  const handler = (evt, name) => {
    evt.preventDefault();

    let iconType = _.find(icons, function (icon) {
      if (
        ((icon.iconType === "sourceOverride" && sourceOverride) || (icon.iconType === "addQC" && qc)) &&
        (icon.icon === name || name === icon.unCheckedIcon || name === icon.warningIcon || name === icon.successIcon)
      ) {
        return true;
      }
      return icon.icon === name;
    });
    // TO DO - This is temp for now we need to improve it.
    if (iconType) {
      if (iconType.actionType === "Popover") {
        if (iconType.iconType === "qcList") {
          setQcList(true);
        } else {
          let selectedValue = '';
          const selectedJobs = _.get(selected, "jobData", []);
          if (selectedJobs.length === 1) {
            const jobValue = _.find(_.get(request, "jobs", []), (jobDataValue) => _.get(jobDataValue, "_id") === _.get(selectedJobs[0], "_id"));
            if (name === "status") {
              selectedValue = _.get(jobValue, name);
            } else if (name === "reassign-active") {
              selectedValue = _.get(jobValue, "assignedTo.fullName");
            } else if (name === 'calendar') {
              selectedValue = _.get(jobValue, 'dueDate')
            }
          }
          setSelectedToolAction({
            event: evt.currentTarget,
            action: getIconAction(iconType),
            icon: name,
            selected: selectedValue||_.get(request,"rolledUpDate"),
          });
        }
      } else if (iconType.actionType === "clickHandler") {
        if (iconType.icon !== "edit" && iconType.icon !== "delete") {
          if (iconType.icon === "QC" && _.get(job, "qcRequired", false)) {
            let alert = {};
            alert["value"] = null;
            alert["id"] = job;
            alert["comment"] = true;
            alert["action"] = iconType.icon;
            alert["message"] = "Please describe why there is no QC for this job";
            alert["title"] = "NO QC";
            setAlert(alert);
          } else {
            updateJob(iconType.icon, null);
          }
        }
        if (!_.isEmpty(currentSelection) && _.get(currentSelection, "selected", false)) {
          if (iconType.icon === "delete") {
            upadateAction({ isEditing: false, action: "edit" });
          } else {
            upadateAction({ isEditing: true, action: "edit" });
          }
        } else if (_.get(selected, "mode") === "request" && iconType.icon === "delete") {
          deleteJob(_.get(selected, "recordId"));
          reset();
        } else if (isSelected && iconType.icon === "edit") {
          if (mode === "summary") {
            history.push("/request?jobId=" + _.get(job, "_id"));
          } else {
            if (_.get(selected, "mode") === "request") {
              if (_.size(_.get(selected, "jobs", [])) === 1 && _.get(selected, "total", -1) > 1) {
                history.push("/request?jobId=" + _.get(selected, "recordId"));
              } else {
                history.push("/request?requestId=" + _.get(selected, "recordId"));
              }
            } else {
              history.push("/request?jobId=" + _.get(selected, "recordId"));
            }
            reset();
          }
        }
      }
    }
  };

  const handleOption = (e) => {
    setSelectedSourceLocation(e?.target?.value);
  }

  const handleSave = async () => {
  setIsSourceLocationModal(false);
  if (currentStatus) {
    // 1st: update source type
    await updateJob("newSourceType", selectedSourceLocation);
    // 2nd: update status
    await updateJob(currentStatus.icon, currentStatus.value);
  } 
  else if (currentAlert) {
    setAlert(currentAlert);
    setAlertSourceLocation(selectedSourceLocation);
  }
  // cleanup
  setCurrentStatus(null);
  setSelectedSourceLocation("");
  setCurrentAlert(null);
};

  const resetTool = () => {
    setSelectedToolAction({
      event: null,
      action: null,
      icon: null,
      selected: null,
    });
  };

  const updateJob = async (action, data, qcValidated: boolean = false, beginQc: boolean = false, isSelectedValue = false) => {
    let updateJobReqBody = {};
    let isExternal = false;
    let selectedJob = {};
    if (mode === "dashboard") {
      selectedJob = _.first(_.get(selected, "jobData"));
    } else {
      selectedJob = (mode === "requestSummary" && !selectAlll) ?
        _.find(_.get(request, "jobs", []), (jobDataValue) => _.get(jobDataValue, "_id") === _.get(_.first(_.get(selected, "jobData")), "_id"))
        : job;
    }
    let isEventScreener = _.get(selectedJob, "jobType") === 'EVENT_SCREENERS';
    let isHoldFlow = _.has(selectedJob, "status") && StatusUtils.checkForWorkFlowStatus(_.get(selectedJob, "status", "")) && data === "TECH_HOLD";
    let isWorkflowCancelled = _.has(selectedJob, "status") && StatusUtils.checkForWorkFlowStatus(_.get(selectedJob, "status", "")) && data === "CANCELLED" && !isEventScreener;
    let apiAction = null;
    switch (action) {
      case "source":
        updateJobReqBody["needsSourceOverride"] = !_.get(selectedJob, "needsSourceOverride", false);
        break;
      case "QC":
        updateJobReqBody["qcRequired"] = !_.get(selectedJob, "qcRequired", false);
        break;
      case "qcUpdate":
        apiAction = Action.QCDONE;
        updateJobReqBody["status"] = "WF_QC_IN_PROGRESS";
        let transcodeVal = _.get(selectedJob, "processor.transcodeQualityCheck", {});
        updateJobReqBody["processor.transcodeQualityCheck"] = Object.assign(transcodeVal, data);
        break;
      case "qcList":
        apiAction = Action.BEGINQC;
        updateJobReqBody["status"] = "WF_QC_IN_PROGRESS";
        updateJobReqBody["processor.transcodeQualityCheck"] = _.get(selectedJob, "processor.transcodeQualityCheck", {
          jobId: _.get(selectedJob, "jobId"),
        });
        break;
      case "status":
        //TO DO :: Need to improve this logic
        if (_.get(selectedJob, "status") === data) {
          return;
        }
        switch (data) {
          case "INITIATE_WORKFLOW":
            isExternal = true;
            updateJobReqBody["status"] = "start";
            break;
          case "RESUME_WORKFLOW":
            apiAction = Action.RESUMEWORKFLOW;
            isExternal = true;
            updateJobReqBody["status"] = "resume";
            break;
          case "COMPLETE":
            isExternal = false;
            updateJobReqBody["status"] = data;
            updateJobReqBody["completedDate"] = moment.utc().toDate();
            apiAction = Action.STATUS;
            break;
          default:
            isExternal = false;
            updateJobReqBody["status"] = data;
            apiAction = Action.STATUS;
            break;
        }
        break;
      case "reassign-active":
        updateJobReqBody["assignedTo"] = isSelectedValue ? null : data;
        apiAction = Action.ASSIGNEE;
        break;
      case 'calendar':
        updateJobReqBody["dueDate"] = isSelectedValue ? null : data;
        apiAction = Action.DUEDATE;
        break;
      case 'newSourceType':
        updateJobReqBody["source.sourceLocation.newLocationSubType"] = isSelectedValue ? null : data;
        break;
    }
    updateJobReqBody["user"] = UserUtils.transformUserInfo(userInfo, true);
    if (mode === "summary") {
      return onJobUpdated(isExternal, updateJobReqBody, false, isWorkflowCancelled, qcValidated, beginQc, isHoldFlow, () => setQcList(true));
    }
    if (mode === "dashboard") {
      return updateRecords(apiAction, _.get(selected, "jobs"), updateJobReqBody, () => setQcList(beginQc), qcValidated, (jobData) => upadateSelection({ ...selected, jobData }), isWorkflowCancelled, isHoldFlow, isExternal);
    }
    if (mode === "requestSummary") {
      resetTool();
      return updateRecordsR(apiAction, _.get(selected, "recordId"), updateJobReqBody, () => setQcList(beginQc), qcValidated, isExternal, isWorkflowCancelled, isHoldFlow);
    }
  };
  const isReadonly = (iconType, statusValue) => {
    return _.includes(["sourceOverride", "addQC"], iconType) && statusValue !== "SUBMITTED";
  };
  const getIconName = (Icon) => {
    if (mode === "requestSummary") {
      if (_.size(_.get(selected, "jobData", [])) >= 1) {
        return Icon.icon;
      } else {
        return Icon.greyIcon;
      }
    }
    if (isSelected || (!_.isEmpty(currentSelection) && _.get(currentSelection, "selected", false))) {
      if (_.size(_.get(selected, "jobs", [])) >= 2) {
        if (Icon.isGrey === true) {
          return Icon.greyIcon;
        }
      } else if (Icon.iconType === "sourceOverride" && enableSourceOverride) {
        if (_.get(job, "needsSourceOverride", false)) {
          return Icon.successIcon;
        } else {
          return Icon.warningIcon;
        }
      } else if (Icon.iconType === "addQC" && enableQc) {
        if (_.get(job, "qcRequired", false)) {
          return Icon.successIcon;
        } else {
          return Icon.warningIcon;
        }
      } else if (Icon.iconType === "qcList" && enableQc) {
        return Icon.icon;
      }
      return Icon.icon;
    } else {
      return Icon.greyIcon;
    }
  };

  return (
    <>
      {mode === "dashboard" || (userRole === "requestor" && mode === "requestSummary") ? (
        !_.isEmpty(selectedColumnAction) || !_.isEmpty(selectedColumnActionR) ? (
          <AppPopoverButton
            job={_.isEmpty(jobData) ? _.isEmpty(job) ? _.get(selected, "jobData") : [job] : [jobData]}
            request={request}
            mode={mode}
            selectedToolActon={mode === "dashboard" ? selectedColumnAction : selectedColumnActionR}
            handleMenu={(alert, action, data) => {
              alert["value"] = data;
              alert["id"] = _.get(selected, "jobs");
              _setColumnAction({});
              _setColumnActionR({});
              setAlert(alert);
            }}
            handleModel={(currentStatus, alert) => {
              //TO DO-Add modal alert
              setUserAlert(alert);
            }}
            handleSelection={(action, data, isSelectedValue) => {
              _setColumnAction({});
              _setColumnActionR({});
              switch (action) {
                case "statusChange":
                  if (mode === "dashboard") {
                    updateJob(_.get(selectedColumnAction, "icon"), _.get(data, "value"));
                  }
                  if (mode === "requestSummary") {
                    updateJob(_.get(selectedColumnActionR, "icon"), _.get(data, "value"));
                  }
                  break;
                case "assignTo":
                  if (mode === "dashboard") {
                    updateJob(_.get(selectedColumnAction, "icon"), data, false, false, isSelectedValue);
                  }
                  if (mode === "requestSummary") {
                    updateJob(_.get(selectedColumnActionR, "icon"), data);
                  }
                  break;
                case "dueDate":
                  if (mode === "dashboard") {
                    updateJob(_.get(selectedColumnAction, "icon"), data, false, false, isSelectedValue);
                  }
                  if (mode === "requestSummary") {
                    updateJob(_.get(selectedColumnActionR, "icon"), data);
                  }
                  break;
                case "QC":
                  updateJob("qcList", null, false, true);
                  break;
                default:
                  break;
              }
            }} />
        ) : null
      ) : (
        <Toolbar
          hidden={showRequestForm}
          style={{
            ...styles,
            background: mode === "summary" || mode === "requestSummary" ? "none" : "#1E1E1E",
          }}>
          {_.map(icons, (Icon, key) => {
            let { iconType, actionType, icon, toolTip } = Icon;
            if (iconType === "addQC") {
              if (!qc) {
                return null;
              }
            }
            if (iconType === "qcList" && !qcCheckList) {
              return null;
            }
            if (iconType === "sourceOverride") {
              if (!sourceOverride) {
                return null;
              }
            }
            //Delete icon is not available to edit when status of job is not draft
            if (
              iconType === "delete" &&
              (_.get(currentSelection, "type") === "source" || _.get(currentSelection, "type") === "process") &&
              !JobUtils.isDrafting(status) &&
              mode === "request"
            ) {
              return null;
            }
            //Hide the delete icon when there is no draft job selected
            if (iconType === "delete" && mode !== "request" && _.get(selected, "status") !== "DRAFT") {
              return null;
            }
            if (iconType === "delete" && mode !== "request" && !_.get(selected, "isDraft", false)) {
              return null;
            }
            if (iconType === "delete" && _.get(selected, "isDraft", false) && !isSelected) {
              return null;
            }
            //Show only edit & delete icon in request form
            if (iconType !== "delete" && iconType !== "editJob" && mode === "request") {
              return null;
            }
            if ((iconType === "editAssignee" || iconType === "editStatus" || iconType === "editDuedate") && _.get(selected, "isDraft", false) && mode === "dashboard") {
              return null;
            }

            //hide editJob & assignee icon for complete & cancelled jobs
            if ((iconType === "editJob" || iconType === "editAssignee" || iconType === "editDuedate") && mode !== "requestSummary") {
              if (
                _.get(selected, "status") === "COMPLETE" ||
                _.get(selected, "status") === "CANCELLED" ||
                _.get(job, "status") === "COMPLETE" ||
                _.get(job, "status") === "CANCELLED"
              ) {
                return null;
              }
            }
            if (iconType === "editJob" && _.size(_.get(selected, "jobs", [])) >= 2 && mode === "dashboard") {
              return null;
            }

            if ((iconType === "editJob" || iconType === "delete" || iconType === "sourceOverride") && mode === "requestSummary") {
              return null;
            }
            if (userRole === "requestor" && mode !== "request") {
              if (
                _.includes(["editJob", "sourceOverride", "editAssignee", "addQC", "qcList", "editDuedate"], iconType) ||
                !_.includes(["SUBMITTED", "ON_HOLD"], _.get(job, "status"))
              ) {
                return null;
              }
            }
            if (iconType === "retryDeliveries" && mode !== "summary" && _.get(job, "status") !== "WF_PARTIAL") {
              return null;
            }
            let id = Math.random().toString(36).substring(7);
            return (
              <div key={"Icon_" + key}>
                {toolTip && toolTip.required ? (
                  <div>
                    <Tooltip title={toolTip.text} placement={toolTip.placement} arrow>
                      <div>
                        <DynamicIcons
                          aria-owns={id}
                          name={getIconName(Icon)}
                          iconClickHandler={handler}
                          iconStyle={iconStyle}
                          readOnly={isReadonly(iconType, _.get(job, "status", ""))}
                        ></DynamicIcons>
                      </div>
                    </Tooltip>
                    {(icon === selectedToolActon.icon && actionType === "Popover") ||
                      (!_.isEmpty(selected) && !selectAlll && !_.isEmpty(selectedColumnActionR)) ? (
                      <AppPopoverButton
                        job={_.isEmpty(jobData) ? _.isEmpty(job) ? _.get(selected, "jobData") : [job] : [jobData]}
                        request={request}
                        mode={mode}
                        selectAll={selectAlll}
                        handleMenu={(alert, action, data) => {
                          alert["value"] = data;
                          alert["id"] = _.get(selected, "jobs");
                          _setColumnActionR({});
                          resetTool();
                          const presentStatus = _.get(job, "status");
                          const nextStatus = _.get(data, "value");
                          const isMediaSupplyChain =
                            _.get(job, "requests[0].sourceType") === "MEDIA_SUPPLY_CHAIN";
                          const isRolePermitted = _.includes(
                            PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES,
                            userRole
                          );

                          let needsSourceModal = false;

                          // Rule 1: Submitted → Cancelled/On Hold/Tech Hold → no modal
                          if (
                            presentStatus === "SUBMITTED" &&
                            skipModalStatuses.includes(nextStatus)
                          ) {
                            needsSourceModal = false;
                          }
                          // Submitted → Submitted → no modal
                          else if (
                            presentStatus === "SUBMITTED" &&
                            nextStatus === "SUBMITTED" 
                          ) {
                            needsSourceModal = false;
                          }
                          // Rule 2: Cancelled/On Hold/Tech Hold → eligible statuses → show modal
                          else if (
                            skipModalStatuses.includes(presentStatus) &&
                            modalTriggerStatuses.includes(nextStatus) &&
                            (!_.has(job, "source.sourceLocation.newLocationSubType") ||
                            _.get(job, "source.sourceLocation.newLocationSubType") === "MEDIA_SUPPLY_CHAIN"
                          )
                          ) {
                            needsSourceModal = true;
                          }
                          // Fallback to "Submitted → others" logic
                          else if (
                            presentStatus === "SUBMITTED" &&
                            !skipModalStatuses.includes(nextStatus)
                          ) {
                            needsSourceModal = true;
                          }

                          if (
                            isRolePermitted &&
                            isMediaSupplyChain &&
                            needsSourceModal &&
                            !hasShownSourceLocationModal &&
                            mode === "summary"
                          ) {
                            setCurrentAlert(alert);
                            setIsSourceLocationModal(true);
                            setHasShownSourceLocationModal(true);
                            return;
                          }
                          if (nextStatus === 'SUBMITTED' && mode === "summary" 
                            && _.get(job, "requests[0].sourceType") === 'MEDIA_SUPPLY_CHAIN') {
                            setHasShownSourceLocationModal(false);
                          }
                          setAlert(alert);
                        }}
                        handleModel={(currentStatus, alert) => {
                          //TO DO-Add modal alert
                          setUserAlert(alert);
                        }}
                        selectedToolActon={selectedToolActon}
                        handleSelection={async (action, data, isSelectedValue) => {
                          const selectedJobs = _.get(selected, "jobData");                          
                          if (selectedJobs.length === 1) {
                            let selectedValue = '';
                            if (!isSelectedValue) {
                              if (action === "statusChange") {
                                selectedValue = _.get(data, "value");
                              } else if (action === "assignTo") {
                                selectedValue = _.get(data, "fullName");
                              } else if (action === "dueDate") {
                                selectedValue = data;
                              }
                              setSelectedToolAction({
                                ...selectedToolActon,
                                selected: selectedValue
                              });
                            }
                          }
                          _setColumnActionR({});
                          resetTool();
                          switch (action) {
                            case "statusChange":
                              if (mode === "requestSummary" && !selectAlll && _.size(_.get(selected, "jobData", [])) < 2) {
                                updateJob("status", _.get(data, "value"));
                              } else {
                                const nextStatus = _.get(data, "value");
                                const presentStatus = _.get(job, "status");
                                const isMediaSupplyChain =
                                  _.get(job, "requests[0].sourceType") === "MEDIA_SUPPLY_CHAIN";
                                const isRolePermitted = _.includes(
                                  PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES,
                                  userRole
                                );

                                let needsSourceModal = false;

                                // Rule 1: Submitted → Cancelled/On Hold/Tech Hold → no modal
                                if (
                                  presentStatus === "SUBMITTED" &&
                                  skipModalStatuses.includes(nextStatus)
                                ) {
                                  needsSourceModal = false;
                                } 
                                // Submitted → Submitted → no modal
                                else if (
                                  presentStatus === "SUBMITTED" &&
                                  nextStatus === "SUBMITTED" 
                                ) {
                                  needsSourceModal = false;
                                }
                                // Rule 2: Cancelled/On Hold/Tech Hold → eligible statuses → show modal
                                else if (
                                  skipModalStatuses.includes(presentStatus) &&
                                  modalTriggerStatuses.includes(nextStatus) &&
                                  (!_.has(job, "source.sourceLocation.newLocationSubType") ||
                                  _.get(job, "source.sourceLocation.newLocationSubType") === "MEDIA_SUPPLY_CHAIN")
                                ) {
                                  needsSourceModal = true;
                                }
                                // Fallback to your old "Submitted → others" logic if still required
                                else if (
                                  presentStatus === "SUBMITTED" &&
                                  !skipModalStatuses.includes(nextStatus)
                                ) {
                                  needsSourceModal = true;
                                }

                                if (
                                  isRolePermitted &&
                                  isMediaSupplyChain &&
                                  needsSourceModal &&
                                  !hasShownSourceLocationModal &&
                                  mode === "summary"
                                ) {
                                  setCurrentStatus({ icon, value: nextStatus });
                                  setIsSourceLocationModal(true);
                                  setHasShownSourceLocationModal(true);
                                  return;
                                }
                                if (nextStatus === 'SUBMITTED' && mode === "summary" 
                                  && _.get(job, "requests[0].sourceType") === 'MEDIA_SUPPLY_CHAIN') {
                                  setHasShownSourceLocationModal(false);
                                  setSelectedSourceLocation("");
                                  if (_.get(job, "source.sourceLocation.newLocationSubType")) {
                                    // Wait for source type update before updating status
                                    await updateJob("newSourceType", "MEDIA_SUPPLY_CHAIN");
                                  }
                                }
                                // Now update status after source type is reverted
                                await updateJob(icon, nextStatus);
                              }
                              break;
                            case "assignTo":
                              if (mode === "requestSummary" && !selectAlll && _.size(_.get(selected, "jobData", [])) < 2) {
                                updateJob("reassign-active", data, false, false, isSelectedValue);
                              } else {
                                updateJob(icon, data, false, false, isSelectedValue);
                              }
                              break;
                            case "dueDate":
                              if (mode === "requestSummary" && !selectAlll && _.size(_.get(selected, "jobData", [])) < 2) {
                                updateJob("calendar", data, false, false, isSelectedValue);
                              } else {
                                updateJob(icon, data, false, false, isSelectedValue);
                              }
                              break;
                            case "QC":
                              let qcVar = mode === "summary" || mode === "requestSummary" ? true : false;
                              updateJob("qcList", null, false, qcVar);
                              break;
                            default:
                              break;
                          }
                        }} />
                    ) : null}
                  </div>
                ) : null}
              </div>
            );
          })}
        </Toolbar>
      )}
      {Boolean(isAlert) ? (
        <AlertDialog
          alertMessage={_.get(isAlert, "message")}
          isAlert={Boolean(isAlert)}
          toolAction={isAlert}
          title={_.get(isAlert, "title", "Please Confirm")}
          onClose={() => {
            setAlert(null);
            setHasShownSourceLocationModal(false);
            setAlertSourceLocation("");
          }}
          onCancel={() => {
            setAlert(null);
            setHasShownSourceLocationModal(false);
            setAlertSourceLocation("");
          }}
          onConfirm={async (data, type, id, noteData) => {
            setAlert(null);
            if (mode === "summary") {
              const role = _.includes(PERMITTED_ROLES.MODAL_SOURCE_LOCATION_ROLES, userRole);
              if (role && _.get(data, "value") === 'SUBMITTED' 
              && _.get(job, "requests[0].sourceType") === 'MEDIA_SUPPLY_CHAIN') {
                setHasShownSourceLocationModal(false);
                setSelectedSourceLocation("");
                if(_.get(job, "source.sourceLocation.newLocationSubType")) {
                  await updateJob("newSourceType", "MEDIA_SUPPLY_CHAIN");
                }
              }
              if (role && alertSourceLocation && _.get(job, "requests[0].sourceType") === 'MEDIA_SUPPLY_CHAIN') {
                await updateJob("newSourceType", alertSourceLocation);
                setAlertSourceLocation("");
              }
              await updateJob(type, _.get(data, "value"));
              onJobUpdated(false, noteData, true);
            }
            if (mode === "dashboard") {
              updateJob(type, _.get(data, "value")).then((response) => {
                updateNotes(id, noteData);
              }).catch((e) => {
                console.log("Error", e);
              });
            }
            if (mode === "requestSummary") {
              updateJob(type, _.get(data, "value")).then((response) => {
                updateNotesRequestSummary(id, noteData);
              }).catch((e) => {
                console.log("Error", e);
              });
            }
          }}
        />
      ) : null}
      {qcListModal ? (
        <QCCheckList
          show={qcListModal}
          job={_.isEmpty(jobData) ? _.isEmpty(job) ? _.first(_.get(selected, "jobData")) : job : jobData}
          onCancel={(hasProgress) => {
            if (hasProgress) {
              setQcList(false);
            } else {
              updateJob("status", "WF_QC_PENDING");
              setQcList(false);
            }
          }}
          onClose={() => {
            setQcList(false);
          }}
          onComplete={(value, qcDone) => {
            updateJob("qcUpdate", value, qcDone);
            setQcList(false);
          }}
        />
      ) : null}
      {!_.isEmpty(userAlert) ? (
        <Modal style={{ zIndex: "100000" }} show={true}>
          <Modal.Header closeButton>
            <Modal.Title>{_.get(userAlert, "title")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{_.get(userAlert, "message")}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => {
                setUserAlert(null);
              }}
              variant="secondary">
              OK
            </Button>
          </Modal.Footer>
        </Modal>
      ) : null}
      {isSourceLocationModal ? (
        <Modal
          className="modal warning-modal"
          show={isSourceLocationModal}
          onHide={() => {
            setIsSourceLocationModal(false);
            setHasShownSourceLocationModal(false);
          }}
          backdrop="static"
          keyboard={false}
          dialogClassName="modalDialog"
        >
          <Modal.Header className="modalHeader" closeButton>
            <Modal.Title className="modalHeaderTitle">Select Source Location</Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBody py-4">
            {renderSourceLocationFields(userRole, handleOption, selectedSourceLocation)}
          </Modal.Body>
          <Modal.Footer>
            <StyledBlueButton disabled={!selectedSourceLocation} onClick={handleSave}>
              Save
            </StyledBlueButton>
          </Modal.Footer>
        </Modal>
      ) : null}
    </>
  );
}

DashboardToolBox.defaultProps = {
  Selected: false,
  selectedItems: [],
  _job: null,
  _setJob: null,
  mode: null,
  isDrafting: true,
  styles: {}
};
